export default __webpack_public_path__ + "e083810d45c8b6541208ca924873fc9d.png";